import config from 'shared/config';
import connector from 'api/http';

import { VehicleFromSearch } from 'scenes/motor/types';

const api = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getVehicleByRego: (
      regoNo: string,
      state: string
    ): Promise<VehicleFromSearch> =>
      server
        .get(`/vehicle/reg/${regoNo}/state/${state}`)
        .then(({ vehicleDetails }) => {
          if (vehicleDetails.length > 0) {
            return { ...vehicleDetails[0], plateNumber: regoNo.toUpperCase() };
          }
          return undefined;
        }),
  };
};

export default api;
